// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1qzM-","content":"GlobalSearch_content__361I4"};